import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import classNames from 'classnames'
import { Line } from 'react-chartjs-2'

import { withStyles } from '@material-ui/core/styles'

import { generateColors } from '../../utils/Colors'

class StackedLineChartView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired, // This is a map of label to datapoints
    formatter: PropTypes.func,
    size: PropTypes.string,
    timeMax: PropTypes.instanceOf(moment),
    timeMin: PropTypes.instanceOf(moment),
  }

  static defaultProps = {
    formatter: (v) => v,
    size: null,
    timeMax: null,
    timeMin: null,
  }

  static styles = () => ({
    chart: {
      position: 'relative',
      minHeight: 200,
    },
    full_height: {
      height: 'calc(100vh - 200px)', // calculate the height based on the viewport height
    },
    half_height: {
      height: 'calc(70vh - 200px)',
    },
  })

  defaultConfig = () => ({
    pointRadius: 0,
    pointHoverRadius: 3,
    lineTension: 0,
    borderWidth: 3,
    borderColor: 'rgba(0, 0, 255, 0.5)',
    fill: false,
  })

  configTimerange() {
    const { timeMax, timeMin } = this.props
    const config = {}
    if (timeMax != null) {
      config.max = timeMax
    }
    if (timeMin != null) {
      config.min = timeMin
    }
    return config
  }

  options() {
    return {
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          type: 'time',
          ticks: {
            major: {
              enabled: true,
            },
          },
          time: {
            ...this.configTimerange(),
            minUnit: 'second',
            displayFormats: {
              // This is used to calculate how many ticks to show, so force it to be extra long.
              millisecond: 'h:mm:ss.SSS a            ',
              hour: 'h:mm a',
              month: 'll',
            },
          },
        }],
        yAxes: [{
          stacked: true,
          offset: true,
          ticks: {
            callback: this.props.formatter,
          },
        }],
      },
    }
  }

  render() {
    const {
      classes, data, size,
    } = this.props

    let clNames = classes.chart
    switch (size) {
      case 'half_height':
        clNames = classNames(clNames, classes.half_height)
        break
      default:
        clNames = classNames(clNames, classes.full_height)
    }

    const labels = Object.keys(data)
    const colors = generateColors(labels.length)
    const datasets = []
    labels.forEach((label) => {
      const color = colors.pop()
      datasets.push({
        ...this.defaultConfig(),
        borderColor: color,
        backgroundColor: color,
        fill: true,
        label,
        data: data[label],
      })
    })
    const chart = { datasets }

    return (
      <div className={clNames}>
        <Line data={chart} options={this.options()} />
      </div>
    )
  }
}

export default withStyles(StackedLineChartView.styles)(StackedLineChartView)
